var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69971 21.0852C9.57584 22.199 10.9522 22.9167 12.4999 22.9167C14.0476 22.9167 15.424 22.199 16.3001 21.0852C13.7774 21.4271 11.2224 21.4271 8.69971 21.0852Z",
    fill: "#52447D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5303 9.37501V10.1084C19.5303 10.9887 19.7816 11.8492 20.2523 12.5815L21.4058 14.3763C22.4596 16.0155 21.6552 18.2437 19.8225 18.7621C15.0284 20.1181 9.9716 20.1181 5.17746 18.7621C3.34484 18.2437 2.54044 16.0155 3.59413 14.3763L4.74771 12.5815C5.21846 11.8492 5.46966 10.9887 5.46966 10.1084V9.37501C5.46966 5.34794 8.61725 2.08334 12.5 2.08334C16.3827 2.08334 19.5303 5.34794 19.5303 9.37501Z",
    fill: "#52447D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.eeec2a3439be2ca10b0c2340d147c748.svg";
export { ForwardRef as ReactComponent };